import functions from '../functions';
import { list } from './list';
import Slider from "../components/Slider";
import {Select2} from "../components/select2";
import pagination from '../components/pagination';
import listResults from '../components/listResults';

$(() => {
    listAccommodation.init();
});

const listAccommodation = {
    $form: null,
    form: null,
    $filter: null,
    filter: null,
    defaults: {
        _page: 1,
        perPage: 9,
        language: functions.getLang(),
        pool: '',
        parking: '',
        pets: '',
        internet: '',
        seaView: '',
        pool: '', 
        dateFrom: null,
        dateTo: null,
        destination: '',
        countryId: '',
        objectGroupId: 1,
        objectTypeId: '',
        guests: '',
        tagCategoryId: null,
        sortBy: null,
    },
    params: {},
    isHome: false,
    $listItems: null,
    filterParams: {
        tagCategoryIds: null,
        categoryObject: null, 
        sortBy: null, 
        objectName: null, 
        distanceBeach: null, 
        distanceCenter: null, 
        pool: null, 
        parking: null, 
        pets: null, 
        internet: null,
        objectTypeId: null,
        heatedPool: null,
        hydromassageBathtub: null,
        grill: null,
        seaView: null,
        ac: null,
        satTV: null,
        dishWasher: null,
        washingMachine: null,
        babyCot: null,
        sauna: null,
    },
    mainFields: ['dateFrom', 'dateTo', 'destination', 'objectTypeId', 'persons', 'personsInObject', 'sortBy', '_page'],
    init() {
        this.$form = $('.search-form');
        this.form = this.$form[0];

        this.$listItems = $('.list-items');
        this.isHome = this.$form.last().attr('data-ishome') || ! this.$listItems.length;
        
        if(! this.form || this.defaults.objectGroupId != this.$form.attr('data-objectgroupid') || this.$listItems.attr('data-objectgroupid') == 10) {
            return;
        }
        
        this.defaults.countryId = this.$form.attr('data-countryid');
        this.defaults.destination = this.$form.attr('data-destination') ? this.$form.attr('data-destination') : this.defaults.countryId;
        this.defaults.tagCategoryId = this.$form.attr('data-tagcategoryid');
        this.filterParams.tagCategoryIds = this.$form.attr('data-tagcategoryids');
        this.defaults.objectTypeId = this.filterParams.objectTypeId = this.$form.attr('data-objecttypeid');
        this.defaults.seaView = this.filterParams.seaView = this.$form.attr('data-seaview');
        this.defaults.pool = this.filterParams.pool = this.$form.attr('data-pool');
        this.defaults.pets = this.filterParams.pets = this.$form.attr('data-pets');

        if(! this.isHome) {

            this.getParams();
            functions.setFormData(this.form, this.params);

            if($('[name=guests]').val()) {
                this.params.guests = $('[name=guests]').val();
            }
            this.find(this.params);
        } else {
            functions.setFormData(this.form, this.defaults);
        }

        this.$form.on('submit', e => {
            const $target = $(e.target);
            e.preventDefault();

            this.isHome = $target.attr('data-ishome') || this.isHome;

            if(this.isHome) {
                this.params.objectGroupId = $target.attr('data-objectgroupid');
                this.params.countryId = this.params.destination = $target.attr('data-countryid');
                this.params.perPage = $target.attr('data-perpage') || this.defaults.perPage;
                this.params = $.extend({}, this.defaults, functions.getFormData($target));
            } else {
                this.getParams();
                this.params = $.extend(this.params, functions.getFormData($target));
            }
            this.params._page = this.defaults._page;

            if(this.isHome) {
                this.params.objectGroupId = $target.attr('data-objectgroupid');
                this.params.tagCategoryId = $target.attr('data-tagcategoryid');
                this.params.objectTypeId = $target.attr('data-objecttypeid');

                let searchParams = {};
                $.map(this.params, (value, key) => {
                    if(value) {
                        searchParams[key] = value;
                    }
                });
                searchParams = functions.cleanParams(this.params, this.defaults);
                location = $target.attr('data-listurl') + '#' + $.param(searchParams);
            } else {
                functions.setUrlData(this.params, true, true, this.defaults);
            }

        });

        $('.ms-clear').on('click', e => {
            e.preventDefault();
            e.stopPropagation();

            this.params.destination = '';

            const $form = $(e.currentTarget).parents('.search-form');
            const form = $form[0];

            $(form.destination).val('').trigger('change');
        });

        $(window).on('hashchange', e => {
            this.getParams();
            this.stopChangeEvents = true;

            functions.scrollToElement(this.$listItems, 100);
            this.find(this.params);
            this.stopChangeEvents = false;
        });

    },
    getParams() {
        this.params = list.getParams(this.params, this.defaults, this.filterParams);
        if(this.params.dates) {
            this.splitCalendarDates(this.params.dates);
        }

        this.params.guests = this.params.guests.startsWith('0') ? null : this.params.guests;
    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(' - ');
            this.params.dateFrom = aDates[0] ? aDates[0] : null;
            this.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    find(params) {
        list.find(params).then((response) => {
            this.findDone(response);
            window.observer.observe();
            //this.initComponents();
        }).fail(error => {
            console.log(error);
        });
    },
    findDone(response) {
        response = JSON.parse(response);          

        list.unsetLoadingMode();

        this.total = response.total;

        this.$listItems.html(response.html);
        if (this.total != 0) {

            if($('.paginate')[0]) {
                $('.paginate').html(pagination({
                    currentPage: this.params._page,
                    total: this.total,
                    perPage: this.params.perPage,
                }));
            }
        }

        listResults.getResults(this.total, this.params._page, this.params.perPage);

        this.initComponents();

    },
    paginate(page) {
        if (page != this.params._page) {
            this.params._page = page;
        }

        functions.setUrlData(this.params, true, false, this.defaults);
    },
    initComponents() {

        // register paginate        
        $('[data-page]').on('click', e => {
            e.preventDefault();
            this.paginate(+$(e.currentTarget).attr('data-page'));
        });

        this.$sortBy = $('[name="sortBy"]');
        this.sortBy = this.$sortBy[0] ? this.$sortBy[0] : null;

        if(this.sortBy && this.params.sortBy) {
            this.$sortBy.each((index, elem) => {
                if(elem.type === 'checkbox') {
                    elem.checked = elem.value === this.params.sortBy;
                } else if(elem.type === 'select-one') {
                    $(elem).val(this.params.sortBy);
                }
            });
        }

        this.$sortBy.on('change', e => {
            let data = functions.getFormData($(e.currentTarget));
            data.sortBy = data.sortBy ? data.sortBy : '11:DESC';
            this.params = $.extend(this.params, this.getParams(), data);
            functions.setUrlData(this.params, true, true, false, this.defaults);
        });

        let listSlider = [];

        $('[id^=card-slider]').each((index, element) => {
            listSlider[index] = new Slider('#' + $(element).attr('id'), {
                rubberband: false,
                loop: true,
                arrows: true,
                slides: {
                    perView: 1,
                    spacing: 0,
                },
            });
        });

        
        this.$filter = $('.search-filter');
        this.filter = this.$filter[0];
        
        this.$filter.find('.select2').each((i, elem) => {
            elem._select2 = new Select2(elem);
        });

        if(this.filter) {
            functions.setFormData(this.filter, this.params);
        }

        this.$filter.on('submit', e => {
            const $target = $(e.currentTarget);
            e.preventDefault();
            e.stopPropagation();

            if ( this.stopChangeEvents ) {
                return;
            }
            
            this.params = $.extend(this.params, this.filterParams, functions.getFormData($target));
            this.params._page = this.defaults._page;
            functions.setUrlData(this.params, true, false, this.defaults);
        });

        $('.btn-clear-filters').on('click', e => {
            e.preventDefault();
            this.params = $.extend(this.params, this.filterParams);
            this.params._page = this.defaults._page;
            functions.setUrlData(this.params, true);
            functions.setFormData(this.filter, this.params, false, this.defaults);
        });
    }
};